import { BaseInputPropsType } from '@/common/components/base/input/base/CommonInput.type';
import input from '@/common/components/base/input/base/input.recipe.ts';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { css, cx } from 'styled-system/css';
import { Box, Center, styled } from 'styled-system/jsx';

const Input = ({
  inputProps,
  errorMessage,
  label,
  inputRef,
  startAttachments,
  endAttachments,
  direction = 'rtl',
  placeholderAlign = 'start',
  hasErrorMassage = true,
  hasLabel = true,
  optionalLabel,
}: BaseInputPropsType) => {
  const startAttachment = startAttachments?.find((item) => item.shouldRender);
  const endAttachment = endAttachments?.find((item) => item.shouldRender);
  const { className, width } = inputProps;
  const attachmentInputStyles = css.raw({
    textAlign: {
      base: 'start',
      _placeholder: placeholderAlign === 'start' ? 'start' : 'end',
    },
  });
  const inputVariants = input({
    isError: !!errorMessage,
    endAttachment: endAttachment?.size,
    startAttachment: startAttachment?.size,
  });
  return (
    <Box className={css({ width: width ?? '' })}>
      {hasLabel ? (
        <Typography height="24px" textStyle="b2">
          {label}{' '}
          {optionalLabel ? (
            <span className={css({ color: 'black-4' })}>(اختیاری)</span>
          ) : null}
        </Typography>
      ) : null}
      <Box dir={direction} position="relative">
        {startAttachment ? (
          <Center className={inputVariants.startAttachment}>
            {startAttachment.element}
          </Center>
        ) : null}
        <styled.input
          ref={inputRef}
          {...attachmentInputStyles}
          {...inputProps}
          className={cx(inputVariants.root, className)}
        />

        {endAttachment ? (
          <Center
            className={cx(inputVariants.endAttachment, endAttachment.height)}
          >
            {endAttachment.element}
          </Center>
        ) : null}
      </Box>
      {hasErrorMassage ? (
        <Typography height="24px" color="red-1" textStyle="b4">
          {errorMessage}
        </Typography>
      ) : null}
    </Box>
  );
};
export default Input;
